<template>
    <!-- eslint-disable max-len -->
    <index-table
        :cols="[
            {
                value: 'name',
                label: 'Name',
                sortable: true,
                searchable: true,
            },
            {
                value: 'type',
                label: 'Type',
                sortable: true,
                searchable: false,
                customCell: 'FrequencySetTypeCell',
            },
            {
                value: 'max_power',
                label: 'Max Power',
                sortable: true,
                searchable: true,
            },
            {
                value: 'bandwidth',
                label: 'Bandwidth',
                sortable: true,
                searchable: true,
            },
            {
                value: 'channels',
                label: 'Channels',
                sortable: false,
                searchable: true,
                customCell: 'ChannelsTableCell',
                display: 'frequency',
            },
        ]"
        :title="'Frequency Sets'"
        :model="'frequency-sets'"
        :options="['deletable']"
        :deleteHandler="deleteHandler"
        data-test-id="frequency-sets-table"
    >
        <template #create>
            <create-frequency-set-menu />
        </template>
        <template #disclaimer>
            <a
                class="disclaimer"
                target="_blank"
                href="https://gotenna.my.site.com/prosupport/s/article/Portal-Navigation-Frequency-Sets"
                >View knowledge base article about creating frequency sets</a
            >
        </template>
    </index-table>
    <!-- eslint-enable max-len -->
</template>

<script>
import canConfirm from '@/mixins/canConfirm'
import IndexTable from '@/components/IndexTable/index.vue'
import CreateFrequencySetMenu from '@/components/CreateFrequencySetMenu.vue'

export default {
    components: {
        CreateFrequencySetMenu,
        IndexTable,
    },

    mixins: [canConfirm],
    methods: {
        async deleteHandler(freqs, showDefaultConfirmation, performDelete) {
            const many = freqs.length > 1
            const anyFreqIsInConfigurationSet = freqs.some((freq) => freq.is_in_configuration_set)

            const confirmed = await this.confirm({
                message: many
                    ? 'Are you sure you want to delete the selected Frequency Sets? This action cannot be undone.'
                    : 'Are you sure you want to delete this Frequency Set? This action cannot be undone.',
                hint: anyFreqIsInConfigurationSet
                    ? `Note: Deleting ${many ? 'these Frequency Sets' : 'this Frequency Set'} won’t affect ` +
                      `existing Configuration Sets using ${many ? 'them' : 'it'}, but any Groups using ` +
                      `${many ? 'these Frequency Sets' : 'this Frequency Set'} will lose ${many ? 'them' : 'it'}.`
                    : null,
                acceptLabel: 'Delete',
                danger: true,
            })

            if (confirmed) {
                performDelete(freqs.map((g) => g.id))
            }
        },
    },
}
</script>
